import { BallActionBase, HandoffActionBase, PlayerActionBase, PossessionActionBase } from "../generic-action";

/** ======== Action Line Types ======== */
export enum SoccerActionLineType {
  SC_RUN = "SC_RUN",
  SC_RUN_AND_STOP = "SC_RUN_AND_STOP",
  SC_DRIBBLE = "SC_DRIBBLE",
  SC_DRIBBLE_AND_STOP = "SC_DRIBBLE_AND_STOP",
  SC_PASS = "SC_PASS",
  SC_SHOT = "SC_SHOT",
  SC_HANDOFF = "SC_HANDOFF",
  SC_RUN_RECEIVING_HANDOFF = "SC_RUN_RECEIVING_HANDOFF",
  SC_RUN_AND_STOP_RECEIVING_HANDOFF = "SC_RUN_AND_STOP_RECEIVING_HANDOFF",
}

export type SoccerPlayerActionLineType = SoccerActionLineType.SC_RUN | SoccerActionLineType.SC_RUN_AND_STOP;
export type SoccerBallActionLineType = SoccerActionLineType.SC_PASS | SoccerActionLineType.SC_SHOT;
export type SoccerHandoffActionLineType = SoccerActionLineType.SC_HANDOFF;
export type SoccerPlayerActionReceivingHandoffLineType =
  | SoccerActionLineType.SC_RUN_RECEIVING_HANDOFF
  | SoccerActionLineType.SC_RUN_AND_STOP_RECEIVING_HANDOFF;
export type SoccerPossessionActionLineType =
  | SoccerActionLineType.SC_DRIBBLE
  | SoccerActionLineType.SC_DRIBBLE_AND_STOP
  | SoccerPlayerActionReceivingHandoffLineType;

/** ======== Actions ======== */
export type SoccerRunAction = PlayerActionBase<SoccerActionLineType.SC_RUN>;
export type SoccerRunAndStopAction = PlayerActionBase<SoccerActionLineType.SC_RUN_AND_STOP>;

export type SoccerDribbleAction = PossessionActionBase<SoccerActionLineType.SC_DRIBBLE>;
export type SoccerDribbleAndStopAction = PossessionActionBase<SoccerActionLineType.SC_DRIBBLE_AND_STOP>;

export type SoccerPassAction = BallActionBase<SoccerActionLineType.SC_PASS>;
export type SoccerShotAction = BallActionBase<SoccerActionLineType.SC_SHOT>;

export type SoccerHandoffAction = HandoffActionBase<SoccerActionLineType.SC_HANDOFF>;

export type SoccerRunReceivingHandoffAction = PossessionActionBase<SoccerActionLineType.SC_RUN_RECEIVING_HANDOFF>;
export type SoccerRunAndStopReceivingHandoffAction =
  PossessionActionBase<SoccerActionLineType.SC_RUN_AND_STOP_RECEIVING_HANDOFF>;

/** ======== Action Groups ======== */
export type SoccerPlayerAction = SoccerRunAction | SoccerRunAndStopAction;
export type SoccerBallAction = SoccerPassAction | SoccerShotAction;
// export type SoccerHandoffAction = SoccerHandoffAction;
export type SoccerNonHandoffPossessionAction = SoccerDribbleAction | SoccerDribbleAndStopAction;
export type SoccerPlayerActionReceivingHandoff =
  | SoccerRunReceivingHandoffAction
  | SoccerRunAndStopReceivingHandoffAction;
